module.exports = __webpack_public_path__ + "7244318390cc4d36aac4a613ff42d308.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Light.woff2
// module id = 973
// module chunks = 0